import { z } from "zod";
import { GroupRole } from "../enum.js";

export const updateMemberRoleSchema = z.object({
	role: z.enum([GroupRole.ADMIN, GroupRole.MEMBER]),
});

export type UpdateMemberRolePayload = z.infer<typeof updateMemberRoleSchema>;
